export default __webpack_public_path__ + "static/media/Camilo-Espinosa-Resume-Jan-22.4050939f.pdf";